import React from "react"
import EpisodeCard from "./EpisodeCard"
import Slider from "./Slider"

const RecommendedEpisodes = ({
  episodes,
  currentEpisode,
  title,
  subtitle,
  upNext,
  isNovel,
  ...overlayProps
}) => (
  <div className="t-ph2">
    <h2 className="tc t-mt3 t-mb3">{title}</h2>
    <h3 className="tc t-mv2">{subtitle}</h3>
    <Slider selectedSlideIdx={currentEpisode} slideCount={episodes.length}>
      {episodes.map((episode, i) =>
        i === currentEpisode ? (
          <EpisodeCard
            key={i}
            upNext={upNext}
            selected
            {...episode}
            {...overlayProps}
          />
        ) : (
          <EpisodeCard key={i} {...episode} {...overlayProps} />
        )
      )}
    </Slider>
  </div>
)

RecommendedEpisodes.defaultProps = {
  title: "EN Enjoying this Story",
  subtitle: "EN Keep Reading:"
}

export default RecommendedEpisodes
